<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Aprovar {{ labelAcordo }}</h2>
    <button
      mat-icon-button
      [mat-dialog-close]="false"
      class="close-button"
      matTooltip="Fechar diálogo"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="dialog-content">
    <div class="sumarizacao-acordos" *ngIf="acordosSelecionados?.length">
      <h4>Você está prestes a aprovar o(s) seguinte(s) acordo(s):</h4>
      <ul>
        <li *ngFor="let acordo of acordosSelecionados">
          Acordo Nº: {{ codigoAcordo(acordo) }} Frota:
          {{ acordo.razaoSocialFrota }}
        </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-12 text-end">
        <button mat-button class="btn-acao" (click)="onCancelar()">
          Voltar
        </button>
        <button
          mat-raised-button
          class="btn-acao btn-confirmar"
          (click)="onConfirmar()"
          [disabled]="loading"
        >
          Aprovar {{ labelAcordo }}
        </button>
      </div>
    </div>
  </div>
</div>
